import GoBackMenu from '@/components/GoBackNavbar';
import NewItem from '@/components/NewItem';
import Constants from '@/Constants';
import { LanguageType } from '@/models/LanguageType';
import { ApplicationState } from '@/store';
import { getCategoriesRequest } from '@/store/category/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const CreateItem: React.FC = () => {
    const [type, setType] = useState<string | null>(null);
    const [language, setLanguage] = useState<LanguageType>('');
    const [advance, setAdvance] = useState(false);

    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { data: identity } = useSelector((state: ApplicationState) => state.identity);

    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        const {
            user: { orgId, applicationId },
        } = identity;
        dispatch(getCategoriesRequest({ orgId, applicationId }));
    }, [dispatch, identity]);

    const renderTitle = () => {
        if (advance) {
            switch (type) {
                case 'article':
                    return strings.ARTICLE;
                case 'audio':
                    return strings.AUDIO;
                case 'link':
                    return strings.LINK;
                case 'video':
                    return strings.VIDEO;
                default:
                    return strings.ITEM;
            }
        }
        return strings.ITEM;
    };

    const handleOnBackClick = () => {
        if (advance) setAdvance(false);
        else history.push('/contents/playlist/items');
    };

    return (
        <>
            <div className="create-item">
                <GoBackMenu confirmable goBackPath={'/contents/playlist/items'} />
                <div className="content">
                    <div className="title">
                        <h1>{`${strings.NEW} ${strings.ITEM}`}</h1>
                        {advance && <span className="item-type">{renderTitle()}</span>}
                    </div>
                    {!advance && (
                        <div className="card">
                            <div className="card-content">
                                <div className="content-row">
                                    <span>{strings.SELECT_MEDIA_TYPE}</span>
                                    <div className="container button-group">
                                        <button
                                            className={`btn btn-primary btn-lg ${type === 'video' ? 'active' : ''}`}
                                            onClick={() => setType('video')}
                                            type="button"
                                        >
                                            <i className="material-icons-outlined align-middle">{Constants.icons.VIDEOCAM}</i>
                                            <span className="align-middle">{strings.VIDEO}</span>
                                        </button>

                                        <button
                                            className={`btn btn-primary btn-lg ${type === 'audio' ? 'active' : ''}`}
                                            onClick={() => setType('audio')}
                                            type="button"
                                        >
                                            <i className="material-icons-outlined align-middle">{Constants.icons.MICROPHONE}</i>
                                            <span className="align-middle">{strings.AUDIO}</span>
                                        </button>
                                    </div>

                                    <div className="container button-group">
                                        <button
                                            className={`btn btn-primary btn-lg ${type === 'article' ? 'active' : ''}`}
                                            onClick={() => setType('article')}
                                            type="button"
                                        >
                                            <i className="material-icons-outlined align-middle">{Constants.icons.FILE_DOCUMENT_OUTLINE}</i>
                                            <span className="align-middle">{strings.ARTICLE}</span>
                                        </button>

                                        <button
                                            className={`btn btn-primary btn-lg ${type === 'link' ? 'active' : ''}`}
                                            onClick={() => setType('link')}
                                            type="button"
                                        >
                                            <i className="material-icons-outlined align-middle">{Constants.icons.LINK}</i>
                                            <span className="align-middle">{strings.LINK}</span>
                                        </button>
                                    </div>
                                </div>

                                <span className={!type ? 'disabled' : ''}>{strings.SELECT_LANGUAGE}</span>

                                <div className="content-row">
                                    <div className="container button-group">
                                        <button
                                            className={`btn btn-primary btn-lg ${language === 'pt' ? 'active' : ''}`}
                                            disabled={!type}
                                            onClick={() => setLanguage('pt')}
                                            type="button"
                                        >
                                            <span className="w-100 align-middle">{strings.LANGUAGE_PT}</span>
                                        </button>

                                        <button
                                            className={`btn btn-primary btn-lg ${language === 'en' ? 'active' : ''}`}
                                            disabled={!type}
                                            onClick={() => setLanguage('en')}
                                            type="button"
                                        >
                                            <span className="w-100 align-middle">{strings.LANGUAGE_EN}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex vertical-center justify-content-end h-100 w-100 submit-buttons">
                                <div>
                                    <button className="btn btn-link" onClick={handleOnBackClick} type="button">
                                        {strings.CANCEL}
                                    </button>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        disabled={!type || !language}
                                        onClick={() => setAdvance(true)}
                                        type="button"
                                    >
                                        {strings.ADVANCE}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {advance && <NewItem handleOnCancel={handleOnBackClick} language={language} type={type} />}
                </div>
            </div>
        </>
    );
};

export default CreateItem;
